module.exports = __webpack_public_path__ + "static/img/viewWarn.588e8a42.png";